<template>
    <el-dialog
    title="预览"
    :visible.sync="iframeSrcDialog"
    :close-on-click-modal="false"
    width="80%"
    :show-close="true"
    top="0px"
    :append-to-body="true"
  >
      <iframe :src="iframeSrc" style="height:100%;width:100%;border:0;" align="middle"></iframe>
  </el-dialog>
</template>

<script>
import { Message } from "element-ui";
import req from "@/request.js";
export default {
    props:["iframeSrc","fileRow"],
    data () {
      return {
        iframeSrcDialog:false,
      }
    },
    methods: {
      handleOpen() {
        this.iframeSrcDialog = true;
      },
      //关闭弹框
      close(){
        this.iframeSrcDialog = false;
      },
      //附件下载
      download(){
        req.download("${portal}/system/file/v1/downloadFile?fileId=" +  this.fileRow.id);
      }
    }
  }
</script>

<style lang="stylus" scoped>
.currentPage {
  cursor: pointer;
  color: #8c8e92;
}

.currentPage:hover {
  color: #2761ff;
}
.arrow{
  position: fixed;
  top: 0px;
  left :0px;
  z-index: 2;
  width: 100%;
  background-color: #191919;
  padding: 12px 0;
  margin: 0;
  text-align :center;
}
>>>.el-dialog__body{
  height: calc(100% - 50px);
  color: #606266;
  font-size: 14px;
  padding:0px;
  padding-left:5px;
}
>>>.el-dialog {
   height: calc(100% );
    position: relative;
    margin: 0 auto 0;
    background: #fff;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 50%;
}
</style>